export default __webpack_public_path__ + "static/banner1_mobile-fb17fcabeca24a9b2e176f3a95904e9c.png";